import PageShell from "@/components/layout/PageShell";
import PageCTA from "@/components/sections/PageCTA";
import Services from "@/components/sections/Services";
import Process from "@/components/sections/Process";
import Testimonials from "@/components/sections/Testimonials";
import FAQ from "@/components/sections/FAQ";

export default function ServicesPage() {
  return (
    <PageShell
      testId="services-page"
      eyebrow="Services"
      title={<>Everything you need to turn your website into a <span className="text-apex-orange">growth engine.</span></>}
      subtitle="Website design, SEO, AEO/GEO for AI search, landing pages, branding, content strategy, performance tracking, and conversion optimization — from one team that ships and measures."
      breadcrumbs={[{ label: "Services" }]}
      seoTitle="Digital Marketing Services | Web Design, SEO, AEO & GEO — APEX Innovation Solutions"
      seoDescription="Explore APEX Innovation Solutions services: high-converting website design, SEO, AEO for AI answer engines (ChatGPT, Perplexity), landing pages, branding, content, and CRO."
    >
      <section className="pb-8 md:pb-10 relative">
        <div className="container-apex">
          <p className="text-white/75 leading-relaxed max-w-4xl" data-align-preserve>
            APEX Innovation Solutions bundles design, engineering, SEO, and content into a single growth practice. Instead of hiring five specialists, you get one team that plans strategy, ships the website, ranks it on Google, gets it cited by AI answer engines like ChatGPT and Perplexity, and continually improves it based on real analytics.
          </p>
        </div>
      </section>

      <Services />
      <Process />
      <Testimonials />
      <FAQ />

      <PageCTA
        title="Which service is right for your business?"
        subtitle="Book a free 30-minute call and we'll map the right mix for your goals and timeline."
        primary={{ label: "Book a Strategy Call", to: "/contact" }}
        secondary={{ label: "See Pricing", to: "/pricing" }}
      />
    </PageShell>
  );
}
